import React from "react";

const ChildSvg = (props) => (
  <svg viewBox="0 0 62.45 59.13" xmlns="http://www.w3.org/2000/svg" width="70" style={{ width: "70px" }} {...props}>
    <path
      d="M31.68 30.75s-11.08 0-15.3 9.85h29.7c-3.84-9.26-14.4-9.85-14.4-9.85z"
      fill="#fff"
      stroke="#ff4909"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
    />
    <path d="M23.85 39a7.7 7.7 0 0 0-1.21 1.56z" fill="#fff" />
    <path
      d="M23.85 39a7.7 7.7 0 0 0-1.21 1.56"
      fill="none"
      stroke="#ff4909"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
    />
    <path d="M39.26 39a8.33 8.33 0 0 1 1.35 1.56z" fill="#fff" />
    <g
      stroke="#ff4909"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
    >
      <path d="M39.26 39a8.33 8.33 0 0 1 1.35 1.56" fill="none" />
      <path
        d="m38.7 22.5 3.29.21a1.94 1.94 0 0 0 .25-3.87L39 18.63z"
        fill="#fff"
      />
      <path
        d="M25.58 18.18 22.3 18a1.94 1.94 0 0 0-.25 3.87l3.29.2z"
        fill="#fdddc2"
      />
      <path
        d="m29.43 27.2-.28 4.25a2.48 2.48 0 1 0 5 .31l.28-4.25z"
        fill="#fff"
      />
    </g>
    <path
      d="M42.24 8.4s-.56 8.67-.77 12.43-3.32 9.81-10 9.43c-5.65-.35-8.62-6-8.69-10S24 7.56 24 7.56"
      fill="#fff"
    />
    <path
      d="M42.24 8.4s-.56 8.67-.77 12.43-3.32 9.81-10 9.43c-5.65-.35-8.62-6-8.69-10S24 7.56 24 7.56"
      fill="none"
      stroke="#ff4909"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
    />
    <path
      d="M20.5 7a2.44 2.44 0 0 1 3-1c-.27-1.49.14-2.47 1.18-3a3.3 3.3 0 0 1 3.15.18C28.08 1.4 28.94.35 30.36.11a4.15 4.15 0 0 1 3.88 1.46A3.08 3.08 0 0 1 37 1.33a2.38 2.38 0 0 1 1.94 2.05 8.67 8.67 0 0 1 3.33 1.39c.72.56.86 1.54.41 2.86a1.87 1.87 0 0 1 2.22 1.71 4 4 0 0 1-.83 3.51 3.64 3.64 0 0 1 .52 2.47c-.17.63-1.21 1.95-3.12 3.94l.32-6a10.51 10.51 0 0 1-2.29-1.05 2.16 2.16 0 0 1-1-1.71 4.86 4.86 0 0 1-2.5-.15 4.13 4.13 0 0 1-2.08-2.13 2.84 2.84 0 0 1-2.52 1.67 4.51 4.51 0 0 1-3.63-1c.13.6-.25 1.29-1.08 2.09a5.09 5.09 0 0 1-3.46 1.26l-.31 5.67a4.09 4.09 0 0 1-2-1.77 1.42 1.42 0 0 1 .52-1.75 2.34 2.34 0 0 1-1.22-1.74 4.32 4.32 0 0 1 .56-2.26A3 3 0 0 1 20.5 7z"
      fill="#ff4909"
    />
    <path d="M37.8 17.2a3.57 3.57 0 0 0-2.7-.55z" fill="#f8e1c3" />
    <path
      d="M37.8 17.2a3.57 3.57 0 0 0-2.7-.55"
      fill="none"
      stroke="#ff4909"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
    />
    <path d="M29.32 16.3a3.87 3.87 0 0 0-2.77.35z" fill="#f8e1c3" />
    <path
      d="M29.32 16.3a3.87 3.87 0 0 0-2.77.35"
      fill="none"
      stroke="#ff4909"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
    />
    <path d="M34.38 27.55v.1l-.14-.14z" fill="#fc4706" />
    <path
      d="M42.24 8.4s0 .48-.07 1.21l-.87-1.28z"
      fill="#fc4706"
      opacity={0.001}
    />
    <path
      d="m28.08 24.62 7.2.87a3.67 3.67 0 0 1-3.88 1.85 3.7 3.7 0 0 1-3.32-2.72z"
      fill="#fff"
      stroke="#ff4909"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
    />
    <path d="M27.45 20.69a1.47 1.47 0 0 1 2.67-.11" fill="#fff" />
    <path
      d="M27.45 20.69a1.47 1.47 0 0 1 2.67-.11"
      fill="none"
      stroke="#ff4909"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
    />
    <path
      d="M36.94 21.52a1.38 1.38 0 0 0-1.21-1.08 1.5 1.5 0 0 0-1.42.59"
      fill="#fff"
    />
    <path
      d="M36.94 21.52a1.38 1.38 0 0 0-1.21-1.08 1.5 1.5 0 0 0-1.42.59"
      fill="none"
      stroke="#ff4909"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
    />
    <path
      d="M27.94 33.74c1.31 1.64 3.81 1.88 3.53.39a17.37 17.37 0 0 1 0-3.9s1.52-.35-1.39-1.4-3.5-4-3.84-6.68 1.11-5.33.86-6.69-1.14-3.93 2.46-4.28 4.4-2.92 4.4-2.92c-2 .87-1.84-1.67-1.84-1.67s-.93.45-2.91-.32-1.31-3.06-1.31-3.06A3.39 3.39 0 0 0 24.72 3c-1.07.49-1.45 1.47-1.18 3a2.36 2.36 0 0 0-3 1 2.92 2.92 0 0 0 .27 3.41 4.3 4.3 0 0 0-.55 2.26 2.35 2.35 0 0 0 1.21 1.74 1.5 1.5 0 0 0-.52 1.75 3.75 3.75 0 0 0 1.91 1.7V18h-.52a1.93 1.93 0 0 0-.25 3.86l.87.07c.59 3.17 2.77 6.69 6.33 7.9l-.07.87c-1.1.18-1.1.49-2.76.84.2.6.16.57 1.48 2.2z"
      fill="#ff4909"
      opacity={0.058}
    />
  </svg>
);

export default ChildSvg;
